/*
 * @Author: 高苏杭
 * @Date: 2024-07-12 16:19:03
 * @LastEditTime: 2024-07-12 16:19:22
 * @Description: 
 */
import AllPagination from './AllPagination';

export default {
  install(Vue) {
    Vue.component('AllPagination', AllPagination);
  }
};


// WEBPACK FOOTER //
// ./src/components/AllPagination/index.js